import { Injectable } from '@angular/core';
import { SelectableData } from 'app/modules/main/components/data-selector/data-selector.models';
import { Offer } from 'app/modules/main/models/offers';

@Injectable({ providedIn: 'root' })
export class OfferSelectorMapper {

  public toOffers(
    selectableOffers: SelectableData<Offer>[]
  ): Offer[] {

    return selectableOffers
      .map(selectedOffer => selectedOffer.data);
  }

  public toSelectableOffers(
    offers: Offer[],
    selectedOffers: Offer[]
  ): SelectableData<Offer>[] {

    const selectedOfferIds =
      new Set(
        selectedOffers
          .map(selectedOffer => selectedOffer.id)
      );

    return offers
      .map(offer => {
        return {
          data: offer,
          id: String(offer.id),
          label: offer.description,
          selected: selectedOfferIds.has(offer.id),
          significantTerms: (
            (offer.type || '') + ' ' +
            (offer.campaign || '') + ' ' +
            (offer.title || '') + ' ' +
            (offer.description || '') + ' ' +
            (offer.voucherCode || '')
          )
            .replace(/\s+/, ' ')
            .trim(),
        };
      });
  }

}
